'use client';
'use strict';

const commonStyles = {
  fontSize: "inherit",
  fontWeight: "inherit",
  textAlign: "inherit",
  bg: "transparent"
};

exports.commonStyles = commonStyles;
